/**
 * Typed-name confirm for a hard, irreversible user delete — same shell as
 * component/WidgetIndex/DeleteModal.jsx, always requiring the typed name
 * (unlike that one, there's no "unpublished, so lighter confirm" case here).
 *
 * @param {Object=} user - null closes the dialog
 * @param {boolean} busy
 * @param {*} error
 * @param {function} onConfirm
 * @param {function} onCancel
 */
import React, { useCallback, useEffect, useState } from "react";
import ConfirmDialog from "../../theme/untitled/ConfirmDialog/ConfirmDialog";
import Input from "../../theme/untitled/Input/Input";
import Icon from "../../theme/untitled/icons/Icon";
import ApiError from "../../component/ApiError";
import styles from "./UsersPage.module.scss";

const DeleteUserDialog = ({ user, busy, error, onConfirm, onCancel }) => {
  const [typedName, setTypedName] = useState("");

  useEffect(() => {
    setTypedName("");
  }, [user?.uuid]);

  const onTypedNameChange = useCallback(
    (e) => setTypedName(e.target.value),
    []
  );

  if (!user) {
    return null;
  }

  const canConfirm = typedName === user.name;

  return (
    <ConfirmDialog
      open
      onClose={onCancel}
      onConfirm={onConfirm}
      icon={<Icon name="Trash01" />}
      title={`Delete ${user.name}?`}
      confirmLabel={busy ? "Deleting…" : error ? "Try again" : "Delete user"}
      confirmDisabled={!canConfirm}
      busy={busy}
    >
      <div className={styles.dialogBody}>
        <p>This permanently deletes the account and everything owned by it.</p>
        <p>This cannot be undone.</p>
        <div className={styles.confirmField}>
          <Input
            size="sm"
            label={`Type "${user.name}" to confirm`}
            value={typedName}
            onChange={onTypedNameChange}
            disabled={busy}
            autoComplete="off"
          />
        </div>
        <ApiError
          error={error}
          defaultErrorMessage="Couldn't delete user. Please try again"
        />
      </div>
    </ConfirmDialog>
  );
};

export default DeleteUserDialog;
